import { LOCAL_IMAGES } from '@qima-labs/app/shared/constants/images.constants';
import { DialogRef } from '@qsp-ui-library/components/modal/shared/classes/dialog.ref';
import { DialogCommonModule } from '@qsp-ui-library/components/modal/shared/components/dialog-common/dialog-common.module';
import { QimaButtonService } from '@qsp-ui-library/services/exported-services/qima-button/qima-button.service';
import { QimaIconService } from '@qsp-ui-library/services/exported-services/qima-icon/qima-icon.service';
import { AppAuthenticationService } from '@qsp-ui-library/services/user-services/app-authentication/app-authentication.service';
import { ChangeDetectionStrategy, Component, Inject, ViewEncapsulation } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { QimaButtonModule } from '@qima/ngx-qima';

@Component({
  selector: 'app-token-expired',
  templateUrl: './token-expired.component.html',
  styleUrls: ['./token-expired.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [DialogCommonModule, TranslateModule, QimaButtonModule],
})
export class TokenExpiredComponent {
  public readonly reTest: string = LOCAL_IMAGES.reTest;

  public constructor(
    @Inject(DialogRef) private readonly _dialogRef: DialogRef<boolean>,
    public readonly qimaButton: QimaButtonService,
    public readonly qimaIcon: QimaIconService,
    private readonly _appAuthenticationService: AppAuthenticationService
  ) {}

  public onLoginClick(): void {
    this._appAuthenticationService.navigateToLogin();
  }

  public onCloseClick(): void {
    this._dialogRef.close(false);
  }
}
